module.exports = __webpack_public_path__ + "img/l.9e36bc59.jpg";